import { useEffect, useState } from 'react'
import { OFFER_DEADLINE } from '../utils/offer'

export type TimeLeft = {
  days: number
  hours: number
  minutes: number
  seconds: number
}

function getTimeLeft(): TimeLeft | null {
  const diff = OFFER_DEADLINE.getTime() - Date.now()
  if (diff <= 0) return null
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  }
}

export function useOfferCountdown(): TimeLeft | null {
  const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(getTimeLeft)

  useEffect(() => {
    const id = window.setInterval(() => setTimeLeft(getTimeLeft()), 1000)
    return () => window.clearInterval(id)
  }, [])

  return timeLeft
}
